module.exports = __webpack_public_path__ + "static/media/Estate Olana King Headboard - 180 cm_White.77c6fe3e.png";